// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4124":"css/admin-app.6842","7134":"css/app.6842"}[chunkId] + ".css";
};